import { render } from "./Lang.vue?vue&type=template&id=373255eb"
import script from "./Lang.vue?vue&type=script&lang=js"
export * from "./Lang.vue?vue&type=script&lang=js"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__